import { MAPBOX_ACCESS_TOKEN } from '../map/map.slice';
import { MapboxGeocodeResponse } from '../models/map/mapbox-geocoding.model';
import { wrapRequest } from './base';

export const getMapboxGeocode = async (
  lng: number,
  lat: number
): Promise<MapboxGeocodeResponse> =>
  wrapRequest(
    'get',
    'mapbox',
    `/geocoding/v5/mapbox.places/${lng},${lat}.json`,
    {
      queryStringParameters: {
        access_token: MAPBOX_ACCESS_TOKEN,
        types: 'country',
      },
    }
  );

export const getMapboxStyle = async (
  styleId: string,
  mapboxAccessToken = MAPBOX_ACCESS_TOKEN
) =>
  wrapRequest('get', 'mapbox', `/styles/v1/${styleId}`, {
    queryStringParameters: {
      access_token: mapboxAccessToken,
    },
  });
